import React, { useState } from "react";
import { createAddress, updateAddress } from "../../../../api";
import { toast } from "react-toastify";
import isvalidateAdddress from "../../../../utils/CheckVaildAddress";
import Loader from "../../../common/loader";

const ShiipingForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [diffAddress, setdiffAddress] = useState({
    name: "",
    number: "",
    apt: "",
    street: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
    phoneNumber: "",
  });
  //   const [Address, setAddress] = useState([]);
  const handleChangeDiffaddress = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setdiffAddress((prevAddress) => ({
      ...prevAddress,
      [name]: value,
    }));
  };

  const handlesetDiffAddresstoAddress = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (diffAddress) {
      const { valid, message } = isvalidateAdddress(diffAddress);
      if (!valid) {
        setLoading(false);
        return toast.error(message);
      }
      if (valid) {
        if (!props.isUpdate) {
          await createAddress(diffAddress)
            .then((res) => {
              setLoading(false);
              props.setAddress([res.data]);
              props.setEditAddress(false);
              toast.success("Address  Saved");
            })
            .catch((error) => {
              setLoading(false);
              toast.error("Something went wrong, Try Again");
            });
        } else {
          await updateAddress(diffAddress, props.id)
            .then((res) => {
              props.setAddress([res.data]);
              setLoading(false);
              props.setEditAddress(false);
              toast.success("Address  Saved");
            })
            .catch((error) => {
              setLoading(false);
              toast.error("Something went wrong, Try Again");
            });
        }
      }
    }
  };

  return (
    <div>
      {loading && <Loader />}
      <form onSubmit={handlesetDiffAddresstoAddress}>
        <h2 className="checkout-title">Shipping Details</h2>
        <div className="row">
          <div className="col-sm-12">
            <label>Full Name *</label>
            <input
              type="text"
              className="form-control"
              name="name"
              value={diffAddress.name}
              onChange={(e) => handleChangeDiffaddress(e)}
              required
            />
          </div>
        </div>

        <label>Street address *</label>
        <input
          type="text"
          className="form-control"
          placeholder="House number and Street name"
          name="number"
          value={diffAddress.number}
          onChange={(e) => handleChangeDiffaddress(e)}
          required
        />
        <input
          type="text"
          className="form-control"
          placeholder="Appartments, suite, unit etc ..."
          name="street"
          value={diffAddress.street}
          onChange={(e) => handleChangeDiffaddress(e)}
          required
        />

        <div className="row">
          <div className="col-sm-6">
            <label>Town / City *</label>
            <input
              type="text"
              className="form-control"
              name="city"
              value={diffAddress.city}
              onChange={(e) => handleChangeDiffaddress(e)}
              required
            />
          </div>

          <div className="col-sm-6">
            <label>State *</label>
            <input
              type="text"
              className="form-control"
              name="state"
              value={diffAddress.state}
              onChange={(e) => handleChangeDiffaddress(e)}
              required
            />
          </div>
        </div>

        <div className="row">
          <div className="col-sm-6">
            <label>Postcode / ZIP *</label>
            <input
              type="text"
              className="form-control"
              name="pincode"
              value={diffAddress.pincode}
              onChange={(e) => handleChangeDiffaddress(e)}
              required
            />
          </div>

          <div className="col-sm-6">
            <label>Country *</label>
            <input
              type="text"
              className="form-control"
              name="country"
              value={diffAddress.country}
              onChange={(e) => handleChangeDiffaddress(e)}
              required
            />
          </div>
        </div>
        <div className="col-sm-6">
          <label>Phone *</label>
          <input
            type="tel"
            className="form-control"
            name="phoneNumber"
            value={diffAddress.phoneNumber}
            onChange={(e) => handleChangeDiffaddress(e)}
            required
          />
        </div>
        {/* <button
      onClick={setDiffAddresstoAddress}
      className="btn btn-outline-primary-2 btn-order btn-block"
    >
      Save
    </button> */}
        <input
          type="submit"
          value="Save"
          className="btn btn-outline-primary-2 btn-order btn-block"
        />
      </form>
    </div>
  );
};

export default ShiipingForm;
